import { ICssConfigItem } from 'src/app/user-identification/models/user-identification';

export function isPixelRadiusVariable(variable: string): boolean {
	return variable.endsWith('_round') || variable.includes('border_round');
}

function unwrapQuotedText(raw: string): string {
	const trimmed = raw.trim();
	const first = trimmed[0];
	const last = trimmed[trimmed.length - 1];
	if ((first === '"' || first === "'") && first === last && trimmed.length >= 2) {
		return trimmed.slice(1, -1);
	}
	return trimmed;
}

/**
 * Normaliza el valor según variable_type para aplicarlo al DOM.
 */
export function formatCssConfigValue(item: ICssConfigItem): string | null {
	const raw = item.value?.trim();
	if (raw === undefined || raw === '' || raw === null) {
		return null;
	}
	switch (item.variable_type) {
		case 'number':
			if (isPixelRadiusVariable(item.variable)) {
				const n = Number.parseFloat(raw);
				if (Number.isNaN(n)) {
					return null;
				}
				return `${n}px`;
			}
			return raw;
		case 'color':
			return raw;
		case 'text':
			// Mantiene stacks CSS válidos, ej: `"Open Sans", sans-serif`.
			return unwrapQuotedText(raw).replace(/\\"/g, '"');
		default:
			return raw;
	}
}
